import { observable } from "mobx";
import { Type } from "class-transformer";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";
import RefundApprovalResponse from "./refundApprovalResponse";
import RefundTransferPaymentResponse from "./refundTransferPaymentResponse";
import type { IRefund } from "./types";
import RefundChargeDetailResponse from "./refundChargeDetailResponse";
import RefundOriginalPayGatePaymentDetailResponse from "./refundOriginalPayGatePaymentDetailResponse";
import RefundFeeResponse from "./refundFeeResponse";
import RefundPermittedActionsResponse from "./refundPermittedActionsResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class PayGateToTransferRefundDetailResponse {
  id!: string;

  @observable
  refundPaymentTemplateId!: string;

  @observable
  refundAmount!: number;

  @observable
  @Type(() => RefundChargeDetailResponse)
  charge?: RefundChargeDetailResponse;

  @observable
  @Type(() => RefundFeeResponse)
  fees!: RefundFeeResponse[];

  @observable
  @Type(() => RefundPermittedActionsResponse)
  permittedActions!: RefundPermittedActionsResponse;

  @observable
  @Type(() => RefundApprovalResponse)
  approvals!: RefundApprovalResponse[];

  @observable
  officialRecordId?: string;

  @observable
  @Type(() => RefundOriginalPayGatePaymentDetailResponse)
  originalPayment!: RefundOriginalPayGatePaymentDetailResponse;

  @observable
  payGatePaymentIdent?: string;

  @observable
  @Type(() => RefundTransferPaymentResponse)
  refundPayment!: RefundTransferPaymentResponse;

  @observable
  @Type(() => DomesticBankAccountResponse)
  refundSenderBankAccount!: DomesticBankAccountResponse;
}

export default class PayGateToTransferRefundDetail extends PayGateToTransferRefundDetailResponse implements IRefund {
  @observable
  @Type(() => RefundApprovalResponse)
  approvals: RefundApprovalResponse[] = [];

  @observable
  isSelectable: boolean;
}
